import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardFormComponent } from './components/card-form/card-form.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { HeaderComponent } from './components/header/header.component';
import { CertificatListTableComponent } from './components/certificatlist-table/certificatlist-table.component';
import { SharedRoutingModule } from './shared-routing.module';
import { FormProfilComponent } from './components/form-profil/form-profil.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditProfilComponent } from './components/edit-profil/edit-profil.component';
import { EditPasswordComponent } from './components/edit-password/edit-password.component';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { SpinnerComponent } from './spinner/spinner.component';
import { TestPersonnalityComponent } from './components/test-personnality/test-personnality.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SideBarMentorComponent } from './components/side-bar/side-bar-mentor/side-bar-mentor.component';
import { SideBarGestionnaireComponent } from './components/side-bar/side-bar-gestionnaire/side-bar-gestionnaire.component';
import { SideBarAprennantComponent } from './components/side-bar/side-bar-apprennant/side-bar-apprenant.component';
import { SideBarAdminComponent } from './components/side-bar/side-bar-admin/side-bar-admin.component';
import { SideBarApprenantStemdComponent } from './components/side-bar/side-bar-apprenant-stemd/side-bar-apprenant-stemd.component';
import { SideBarMentorStemdComponent } from './components/side-bar/side-bar-mentor-stemd/side-bar-mentor-stemd.component';
import { PersonnelForcenComponent } from '../agenda/components/create-activity/personnel-forcen/personnel-forcen.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SideBarPersonelCompanyComponent } from './components/side-bar/side-bar-personel-company/side-bar-personel-company.component';
import { SideBarHorsFormationComponent } from './components/side-bar/side-bar-hors-formation/side-bar-hors-formation.component';
import { InfoAppelComponent } from './components/info-appel/info-appel.component';
import { SideBarPartnerComponent } from './components/side-bar/side-bar-partner/side-bar-partner.component';
import { SideBarGestionnaireBeninComponent } from './components/side-bar/side-bar-gestionnaire-benin/side-bar-gestionnaire-benin.component';
import { SideBarMentorFccComponent } from './components/side-bar/side-bar-mentor-fcc/side-bar-mentor-fcc.component';
import { SideBarResponsableCertificatFccComponent } from './components/side-bar/side-bar-responsable-certificat-fcc/side-bar-responsable-certificat-fcc.component';
// import { SoftskillComponent } from './components/softskill/softskill.component';
import { ConsentementComponent } from './components/consentement/consentement.component';
import { RouterModule } from '@angular/router';
import { SideBarFinanceBeninComponent } from './components/side-bar/side-bar-finance-benin/side-bar-finance-benin.component';
import { IframeModalComponent } from './components/iframe-modal/iframe-modal.component';
import { SafeUrlPipe } from './components/iframe-modal/safe-url.pipe';

@NgModule({
  declarations: [
    CardFormComponent,
    SideBarComponent,
    HeaderComponent,
    CertificatListTableComponent,
    FormProfilComponent,
    EditProfilComponent,
    EditPasswordComponent,
    OnlyNumberDirective,
    SpinnerComponent,
    TestPersonnalityComponent,
    BreadcrumbComponent,
    SideBarMentorComponent,
    SideBarGestionnaireComponent,
    SideBarAprennantComponent,

    SideBarAdminComponent,
    SideBarApprenantStemdComponent,
    SideBarMentorStemdComponent,
    PersonnelForcenComponent,
    SideBarPersonelCompanyComponent,
    SideBarHorsFormationComponent,
    InfoAppelComponent,
    SideBarPartnerComponent,
    SideBarGestionnaireBeninComponent,
    SideBarMentorFccComponent,
    SideBarResponsableCertificatFccComponent,
    // SoftskillComponent,
    ConsentementComponent,
    SideBarFinanceBeninComponent,
    IframeModalComponent,
    SafeUrlPipe
  ],

  imports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    FormsModule,
  ],
  exports: [
    CardFormComponent,
    SideBarComponent,
    HeaderComponent,
    CertificatListTableComponent,
    FormProfilComponent,
    EditProfilComponent,
    EditPasswordComponent,
    OnlyNumberDirective,
    SpinnerComponent,
    TestPersonnalityComponent,
    BreadcrumbComponent,
    PersonnelForcenComponent,
    InfoAppelComponent,
    ReactiveFormsModule,
    FormsModule,
    IframeModalComponent
  ],
})
export class SharedModule { }
